'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  ', '\n  margin: 14px 0 0 0;\n'], ['\n  ', '\n  margin: 14px 0 0 0;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  ', ';\n'], ['\n  ', ';\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  ', '\n  ', ';\n  &:hover{\n    color: ', '\n  }\n'], ['\n  ', '\n  ', ';\n  &:hover{\n    color: ', '\n  }\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  ', '\n  margin-top: 14px;\n'], ['\n  ', '\n  margin-top: 14px;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _buoyText = require('buoy-text');

var _buoyTheme = require('buoy-theme');

var _buoyConfig = require('buoy-config');

var _dist = require('react-intl/dist');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var date = new Date();
var currentYear = date.getFullYear();

var LegalLinks = (0, _styledComponents2.default)(_buoyText.Paragraph).withConfig({
  displayName: 'Copyright__LegalLinks',
  componentId: 'sc-47tzgw-0'
})(_templateObject, (0, _buoyTheme.fontSize)('bodySmall'));

var CopyRight = _styledComponents2.default.span.withConfig({
  displayName: 'Copyright__CopyRight',
  componentId: 'sc-47tzgw-1'
})(_templateObject2, (0, _buoyTheme.responsive)("margin-right", "60px", "60px", "60px", "60px", "20px"));

var StyledLink = (0, _styledComponents2.default)(_buoyText.Link).withConfig({
  displayName: 'Copyright__StyledLink',
  componentId: 'sc-47tzgw-2'
})(_templateObject3, (0, _buoyTheme.fontSize)("bodySmall"), (0, _buoyTheme.responsive)("margin-right", "20px", "20px", "20px", "20px", "15px"), _buoyTheme.colors["neutralDark"]);

var StyledParagraph = (0, _styledComponents2.default)(_buoyText.Paragraph).withConfig({
  displayName: 'Copyright__StyledParagraph',
  componentId: 'sc-47tzgw-3'
})(_templateObject4, (0, _buoyTheme.fontSize)("bodySmall"));

var Copyright = function Copyright(_ref) {
  var links = _ref.links,
      baseUrl = _ref.baseUrl;
  return _react2.default.createElement(
    _react2.default.Fragment,
    null,
    _react2.default.createElement(
      LegalLinks,
      { color: 'neutral' },
      _react2.default.createElement(
        CopyRight,
        null,
        '\xA9 Buoy Health, Inc. ',
        currentYear
      ),
      links.map(function (link) {
        return _react2.default.createElement(
          StyledLink,
          {
            key: link.text,
            color: 'neutral',
            underline: false,
            href: (0, _buoyConfig.getAbsoluteUrl)(link.href, baseUrl)
          },
          link.text === "Terms" ? _react2.default.createElement(_dist.FormattedMessage, {
            id: 'footer.legal.terms',
            defaultMessage: link.text
          }) : link.text === "Privacy" ? _react2.default.createElement(_dist.FormattedMessage, {
            id: 'footer.legal.terms',
            defaultMessage: link.text
          }) : link.text === "Cookies" ? _react2.default.createElement(_dist.FormattedMessage, {
            id: 'footer.legal.cookies',
            defaultMessage: link.text
          }) : link.text === "Editorial" ? _react2.default.createElement(_dist.FormattedMessage, {
            id: 'footer.legal.editorial',
            defaultMessage: link.text
          }) : ""
        );
      })
    ),
    _react2.default.createElement(
      StyledParagraph,
      { color: 'neutral', margin: '0' },
      _react2.default.createElement(_dist.FormattedMessage, {
        id: 'footer.copyright',
        defaultMessage: 'The content available on buoyhealth.com is not a substitute for professional medical advice, diagnosis, or treatment.'
      })
    )
  );
};

exports.default = Copyright;


//////////////////
// WEBPACK FOOTER
// ./~/buoy-footer/dist/components/Copyright.js
// module id = 408
// module chunks = 168707334958949